module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAAAXNSR0IArs4c6QAAAFdJREFUKFNjZLg+v4HhF3M3g37cVwYkwMhwfcEXBob/PeiSIIn/DAwMX8GSmokNME0wCSj/fyNMJ5oEVOcv5m50CZBOsLFES0AcgWkUpuVYnYvLg9iDBABQJUj1uver5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/arrow-right-s-fill.png
// module id = Ccdc
// module chunks = 9